<template>
  <div class="form-group mt-20">
    <div class="col-sm-5 col-md-12 col-lg-12">
      <label :for="id" class="custom-title">{{ title }}</label>
      <popover :content="tooltip" v-if="tooltip" />
    </div>
    <div class="col-sm-5 col-md-12 col-lg-12 ml-15">
      <div class="pencil-box tablet-view"><span class="fas fa-pencil"></span></div>
      <input
        type="color"
        id="theme-colors"
        class="theme-colors"
        :name="id"
        @change="updateColor"
        :value="value"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tooltip: {
        type: String,
      },
      id: {
        type: String,
      },
      value: {
        type: String,
      },
      title: {
        type: String,
      },
    },
    methods: {
      updateColor(e) {
        this.$emit('input', e.target.value);
      },
    },
  };
</script>
<style lang="scss" scoped>
  // tablet view
  @media (min-width: 768px) and (max-width: 991px) {
    .tablet-view {
      padding-top: 0.78rem !important;
    }
  }

  .fa-pencil {
    transform: translateY(-3px);
  }

  .pencil-box,
  .tablet-view {
    background-color: #707070;
    color: #ffffff;
    width: 26px;
    display: inline-block;
    padding-top: 8px;
    transform: translateX(6px);
    text-align: center;
    height: 32px;
  }

  .custom-title {
    margin-left: 20px;
    font-weight: bold;
  }

  #theme-colors {
    width: 108px;
    height: 32px;
    display: inline-block;
  }
</style>
